module.exports = __webpack_public_path__ + "media/cow.4c0f0649.mp3";